import React, { useEffect, useState } from 'react';

//Material
import { Box, Menu, MenuItem, Paper, Rating, Typography } from '@mui/material';
// import { Stack } from '@mui/system';
import { connect, useDispatch, useSelector } from 'react-redux';
import basePhoto from '../assets/DefaultIMG.png';
import ApiService from '../helpers/apiHelper';
import '../pages/MainPage/index.css';
import {
  setIsOpenAuthModal,
  setIsOpenComplainModal,
  setIsOpenDeleteAttentionModal,
  setIsOpenDeleteModal,
  setIsOpenResendingModal,
  setIsOpenServiceModal,
  setIsOpenServicePromoteModal,
  setUserSavedServices
} from '../redux/mainReducer';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import { MoreHoriz } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

function ServiceCardRibbonInt({
  index,
  el,
  noWidth = false,
  maxHeight = 'unset',
  isInRibbon = false,
  dataSetter,
  ...props
}) {
  // eslint-disable-next-line

  const apiSavedService = new ApiService('posts/saved-service');
  const apiDelete = new ApiService(`posts/service`);
  const apiComplaint = new ApiService('auth/user/complaint-user');
  // const apiSavedService = new ApiService('saved-service');
  // const apiDelete = new ApiService(`service`, translate);
  // const apiComplaint = new ApiService('/user/complaint-user');

  const [photos, setPhotos] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const userData = useSelector((state) => state.global.userData);
  const userSavedServices = useSelector((state) => state.global.userSavedServices);
  const language = useSelector((state) => state.Intl.locale);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteService = (id) => {
    apiDelete
      .deleteItem(id)
      .then((res) => {
        dataSetter(true);
        enqueueSnackbar('Товар успішно видалено', { variant: 'success' });
        dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
      })
      .catch((error) => {
        if (
          error?.message &&
          error?.message === 'You cant delete this service because that have orders'
        ) {
          dispatch(setIsOpenDeleteAttentionModal(true));
        }
      });
  };
  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(userData?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };

  useEffect(() => {
    let mounted = true;

    if (el?.photoUrls && el?.photoUrls.length !== 0 && mounted) {
      setPhotos([...el?.photoUrls]);

      return () => (mounted = false);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Paper
      {...props}
      key={index}
      sx={{
        opacity:
          window.location.href.includes('user-page') &&
          userData?.id === el?.userDTO?.id &&
          userData?.role !== 'PREMIUM_USER' &&
          !el?.isActive
            ? '0.3'
            : '1',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        backgroundColor: 'white',
        border: 'none',
        borderRadius: '5px',
        padding: { xs: !isInRibbon ? '4px' : '8px', sm: '8px', md: !isInRibbon ? '8px' : '16px' },
        maxHeight: { xs: !isInRibbon ? '68px' : '108px', sm: '108px', md: '228px' },
        // minHeight: { xs: '100px', md: '228px' },
        maxWidth: { xs: !isInRibbon ? '50%' : '100%', sm: '100%' },
        width: '600px',
        // minWidth: { xs: isInRibbon ? '250px' : '350px', sm: '246px', md: '276px' },
        position: 'relative',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
        // '&:hover':
        //   isHoverMy || isHoverSearch || isHoverSaved
        //     ? {}
        //     : { boxShadow: '-10px 10px 3px black', transform: 'scale(1.025)', transition: 'all 1s' }
      }}
    >
      {isInRibbon && (
        <div
          id="positioned-button"
          aria-controls={open ? 'service-positioned-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            width: '30px',
            height: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50px',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer',
            top: '8px',
            right: '8px',
            zIndex: 101
          }}
        >
          <MoreHoriz />
        </div>
      )}
      <Menu
        anchorEl={anchorEl}
        id="action-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'hidden',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            borderRadius: '4px',
            border: 'none',
            paddingTop: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
            width: '283px',
            mt: 1
          }
        }}
        autoFocus={false}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          sx={{
            borderRadius: '4px',
            ':hover': { backgroundColor: '#E2F2FF' },
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            window.open(`${window.location.origin}/${props?.language}/service/${el.id}`);
            window.scrollTo({ top: 0 });

            handleClose();
          }}
        >
          Сторінка товару
        </MenuItem>

        {el?.userRibbonDTO?.id === userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#E2F2FF' },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(setIsOpenServiceModal({ isOpen: true, data: el, setter: dataSetter }));
            }}
          >
            Редагувати
          </MenuItem>
        )}
        {el?.userRibbonDTO?.id === userData?.id && !el?.isBlocked && (
          <MenuItem
            sx={{
              ':hover': { backgroundColor: '#E2F2FF' },
              borderRadius: '4px',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              if (userData.role === 'PREMIUM_USER') {
                dispatch(
                  setIsOpenServicePromoteModal({
                    isOpen: true,
                    id: el?.id,
                    title: el?.nameService,
                    setter: dataSetter
                  })
                );
                handleClose();
              } else {
                navigate('/ua/tariffs');
              }
            }}
          >
            Просувати
          </MenuItem>
        )}

        <MenuItem
          sx={{
            ':hover': { backgroundColor: '#E2F2FF' },
            borderRadius: '4px',
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            handleClose();
            dispatch(setIsOpenResendingModal({ isOpen: true, id: el.id, type: 'service' }));
          }}
        >
          Відправити у повідомлення
        </MenuItem>

        <MenuItem
          sx={{
            borderRadius: '4px',
            ':hover': { backgroundColor: '#E2F2FF' },

            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            navigator.clipboard.writeText(`${window.location.origin}/ua/service/${el?.id}`);
            handleClose();
            enqueueSnackbar('Посилання на товар скопійовано', { variant: 'success' });
          }}
        >
          Скопіювати посилання
        </MenuItem>

        <MenuItem
          sx={{
            borderRadius: '4px',
            ':hover': { backgroundColor: '#E2F2FF' },
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            handleClose();

            window.open(`${window.location.origin}/${props?.language}/support`);
            window.scrollTo({ top: 0 });
          }}
        >
          Підтримка
        </MenuItem>

        {el?.userRibbonDTO?.id !== userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#FFE5E5' },

              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(
                setIsOpenComplainModal({
                  isOpen: true,
                  func: sendComplaint
                })
              );
            }}
          >
            Поскаржитись
          </MenuItem>
        )}
        {el?.userRibbonDTO?.id === userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#FFE5E5' },

              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(
                setIsOpenDeleteModal({
                  isOpen: true,
                  text: 'цей товар?',
                  func: deleteService,
                  id: el?.id
                })
              );
            }}
          >
            Видалити товар
          </MenuItem>
        )}
      </Menu>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'start',
          gap: { xs: '8px', md: '16px' },
          position: 'relative'
          // maxHeight: { xs: isInRibbon ? '369px' : '454px', sm: '350px', md: '394px' },
          // minHeight: { xs: isInRibbon ? '369px' : '454px', sm: '350px', md: '394px' },
          // maxWidth: { xs: isInRibbon ? '250px' : '350px', sm: '246px', md: '276px' },
          // minWidth: { xs: isInRibbon ? '250px' : '350px', sm: '246px', md: '276px' }
        }}
      >
        <Box
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            // navigate(`/${language}/service/${el.id}`)*/}
            if (userData?.id) {
              // navigate(`/${language}/service/${el.id}`);*/}
              window.open(`${window.location.origin}/${language}/service/${el.id}`);
            } else {
              dispatch(setIsOpenAuthModal(true));
            }
          }}
          sx={{
            borderRadius: '8px',
            minHeight: {
              xs: isInRibbon ? '84px' : '60px',
              sm: isInRibbon ? '84px' : '92px',
              md: isInRibbon ? '180px' : '92px'
            },
            maxHeight: {
              xs: isInRibbon ? '84px' : '60px',
              sm: isInRibbon ? '84px' : '92px',
              md: isInRibbon ? '180px' : '92px'
            },
            minWidth: {
              xs: isInRibbon ? '84px' : '60px',
              sm: isInRibbon ? '84px' : '92px',
              md: isInRibbon ? '180px' : '92px'
            },
            maxWidth: {
              xs: isInRibbon ? '84px' : '60px',
              sm: isInRibbon ? '84px' : '92px',
              md: isInRibbon ? '180px' : '92px'
            },
            cursor: 'pointer'
          }}
        >
          {el !== null &&
          el &&
          el?.photoUrls &&
          el?.photoUrls.length !== 0 &&
          el?.photoUrls.length === 1 &&
          photos.length !== 0
            ? photos.map(
                (photo, index) =>
                  index === 0 && (
                    <img
                      key={`photo${index}`}
                      src={photo}
                      alt={`illustration`}
                      style={{
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        borderRadius: '8px'
                      }}
                    />
                  )
              )
            : null}
          {/* {isLoadingPhotos && (
              <Skeleton
                sx={
                  maxHeight !== 'unset'
                    ? { height: 240, width: 240, margin: '0 auto' }
                    : { height: 370, width: 370, margin: '0 auto' }
                }
                animation="wave"
                variant="rectangular"
              />
            )} */}
          {el !== null &&
            el &&
            el?.photoUrls &&
            el?.photoUrls.length !== 0 &&
            el?.photoUrls.length > 1 &&
            photos.length !== 0 &&
            photos.map(
              (photo, index) =>
                index === 0 && (
                  <img
                    key={`photo${index}`}
                    src={photo}
                    alt={`photo-il`}
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  />
                )
            )}
          {(el !== null && !el?.photoUrls) ||
          (el !== null && el?.photoUrls && el?.photoUrls.length === 0) ? (
            <img
              src={basePhoto}
              alt="defaultImg"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            />
          ) : null}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', p: '0px' }}>
          <Typography
            // variant="subtitle"
            sx={{
              fontSize: { xs: '12px', sm: '14px', md: !isInRibbon ? '16px' : '24px' },
              fontFamily: 'FixelText-Medium',
              fontWeight: 500,
              margin: '0px 0px 0px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {el.nameService}
          </Typography>
          <Typography
            sx={{
              display: { xs: !isInRibbon ? 'none' : 'inline-block', sm: 'inline-block' },
              fontSize: { xs: '12px', md: !isInRibbon ? '14px' : '16px' },
              margin: '0px 0px 0px',
              fontFamily: 'FixelText-Medium',
              textAlign: 'left',
              fontWeight: '500',
              color: '#7C7C7C'
            }}
          >
            {`@${el?.userRibbonDTO?.nickname}`}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '12px', md: !isInRibbon ? '14px' : '24px' },
              margin: !isInRibbon ? '0px' : '8px 0px',
              fontFamily: 'FixelText-Medium',
              textAlign: 'left',
              fontWeight: '500'
            }}
          >
            {`${el.price} ${el.currency}`}
          </Typography>
          <Typography
            sx={{
              display: { xs: !isInRibbon ? 'none' : 'flex', sm: 'flex' },
              color: '#868686',
              fontSize: { xs: isInRibbon ? '12px' : '14px', sm: '14px' },

              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '0px 0px 8px'
            }}
            variant="subtitle"
          >
            <Rating
              sx={{
                fontSize: { xs: isInRibbon ? '12px' : '18px', sm: '18px' },
                ml: '0px',
                mb: !isInRibbon ? '0px' : '4px'
              }}
              value={el.rating}
              precision={0.5}
              readOnly
            />
          </Typography>
        </Box>
        <Box
          sx={{
            display: { xs: !isInRibbon ? 'none' : 'flex', sm: 'flex' },
            flexDirection: 'column',
            p: '0px',
            justifyContent: 'flex-end',
            ml: 'auto'
          }}
        >
          {userData && userSavedServices.length !== 0 && userSavedServices.includes(el.id) ? (
            <BookmarkIcon
              onClick={() => {
                if (userData?.id) {
                  if (!el?.isBlocked) {
                    apiSavedService.deleteItemQuery({ postId: el.id }).then((res) => {
                      // dataSetter();
                      const newArray = userSavedServices.filter((id) => el.id !== id);
                      dispatch(setUserSavedServices([...newArray]));
                    });
                  }
                } else {
                  dispatch(setIsOpenAuthModal(true));
                }
              }}
              sx={{
                zIndex: 200,
                width: { xs: '20px', md: '24px' },
                height: { xs: '28px', md: '30px' },
                cursor: 'pointer',
                color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                mb: !isInRibbon ? '0px' : '8px',
                ':hover': {
                  color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                  cursor: !el?.isBlocked ? 'pointer' : 'default'
                }
              }}
            />
          ) : (
            <BookmarkBorderOutlinedIcon
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (userData?.id) {
                  if (!el?.isBlocked) {
                    apiSavedService.updateDataQueryPost({ serviceId: el.id }).then((res) => {
                      // dataSetter();
                      const newArray = [...userSavedServices, el.id];
                      dispatch(setUserSavedServices([...newArray]));
                    });
                  }
                } else {
                  dispatch(setIsOpenAuthModal(true));
                }
              }}
              sx={{
                zIndex: 200,
                width: { xs: '20px', md: '24px' },
                height: { xs: '28px', md: '30px' },
                color: el?.isBlocked && 'lightgray',
                cursor: !el?.isBlocked ? 'pointer' : 'default',
                mb: !isInRibbon ? '0px' : '8px',
                '&:hover': {
                  color: !el?.isBlocked ? '#EFC938' : 'lightgray'
                }
              }}
            />
          )}
        </Box>
      </Box>
      {/*{(userData && userData?.role === 'PREMIUM_USER' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'USER' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'ADMIN' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'SUPER_ADMIN' && el?.isActive) ? (*/}
      {/*  <LetsGoBtn*/}
      {/*    className="service-card-btn"*/}
      {/*    width="200px"*/}
      {/*    margin="10px auto"*/}
      {/*    text="Детальніше"*/}
      {/*    onClick={() => {*/}
      {/*      // navigate(`/${language}/service/${el.id}`)*/}
      {/*      if (userData?.id) {*/}
      {/*        // navigate(`/${language}/service/${el.id}`);*/}
      {/*        window.open(`${window.location.origin}/${language}/service/${el.id}`);*/}
      {/*        window.scrollTo({ top: 0 });*/}
      {/*      } else {*/}
      {/*        dispatch(setIsOpenAuthModal(true));*/}
      {/*      }*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
      {/*{window.location.href.includes('search') ||*/}
      {/*window.location.href.includes('ribbon') ||*/}
      {/*window.location.href.includes('saved') ? (*/}
      {/*  <LetsGoBtn*/}
      {/*    className="service-card-btn"*/}
      {/*    width="200px"*/}
      {/*    margin="10px auto"*/}
      {/*    text="Детальніше"*/}
      {/*    onClick={() => {*/}
      {/*      // navigate(`/${language}/service/${el.id}`)*/}
      {/*      if (userData?.id) {*/}
      {/*        // navigate(`/${language}/service/${el.id}`);*/}
      {/*        window.open(`${window.location.origin}/${language}/service/${el.id}`);*/}
      {/*        window.scrollTo({ top: 0 });*/}
      {/*      } else {*/}
      {/*        dispatch(setIsOpenAuthModal(true));*/}
      {/*      }*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
      {/*{window.location.href.includes('user-page') && !el?.isActive ? (*/}
      {/*  <LetsGoBtn2*/}
      {/*    className="service-card-btn"*/}
      {/*    disabled={userData?.role !== 'PREMIUM_USER' ? true : false}*/}
      {/*    width="120px"*/}
      {/*    margin="10px auto 10px !important"*/}
      {/*    text="Активувати"*/}
      {/*    onClick={() => {*/}
      {/*      apiActivateId*/}
      {/*        .updateDataQuery({ serviceId: el?.id, isActive: true })*/}
      {/*        .then((res) => {*/}
      {/*          dataSetter(true);*/}
      {/*        })*/}
      {/*        .catch((error) => {*/}
      {/*          console.error(error);*/}
      {/*          enqueueSnackbar('Послугу не активовано!', { variant: 'error' });*/}
      {/*        });*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
    </Paper>
  );
}
const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(ServiceCardRibbonInt);
